module.exports = __webpack_public_path__ + "static/media/reflexive_pronouns0_img.d25f9367.JPG";